import { Button } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';
import { currentUser } from 'helpers/authentication';
import { openLandingPageMembership, openPaymentPageMembership } from 'helpers/utils';
import Page from 'ui/design-base/Page';
import PremiumManagementContent from 'ui/design-base/PremiumManagementContent';
import { PricingCard } from 'ui/design-base/PricingCard';
import type { PricingTier } from 'types/misc';

export const PremiumPage = () => {
  const user = currentUser();
  const isPremium = user?.premium;
  const navigate = useNavigate();

  const pricingTiers: PricingTier[] = [
    {
      name: 'Gratis',
      price: 0,
      period: 'per sempre',
      description: 'Perfetto per iniziare, classifiche match e tornei.',
      onClick: () => navigate('/profilo'),
      features: [
        { name: 'Funzionalità TennisTalker BASE', included: true },
        { name: 'Rimuovi pubblicità APP/Sito Web', included: false },
        { name: 'Classifica Super Simulata', included: false },
        { name: 'Ricerche filtrate - migliori per età, provincia...', included: false },
        { name: '15% Tennis Warehouse Europe', included: false },
        { name: 'Classifica Armonizzata', included: false },
      ],
    },
    {
      name: 'Club Membership',
      price: 2.99,
      period: 'mese (con pagamento annuale)',
      description: 'Per chi vuole il meglio da TennisTalker.',
      isPopular: true,
      onClick: openPaymentPageMembership,
      features: [
        { name: 'Funzionalità TennisTalker BASE', included: true },
        { name: 'Rimuovi pubblicità APP/Sito Web', included: true },
        { name: 'Classifica Super Simulata', included: true },
        { name: 'Ricerche filtrate - migliori per età, provincia...', included: true },
        { name: '15% Tennis Warehouse Europe', included: true },
        { name: 'Classifica Armonizzata', included: true },
      ],
    },
  ];

  const landingLink = (
    <div className='bg-accent-accent-2 px-4 py-6'>
      <div className='text-center'>
        <h1 className='text-4xl font-bold sm:text-5xl'>
          Accedi a questo e tanti altri contenuti grazie alla Club Membership
        </h1>
        <p className='mx-auto my-4 max-w-2xl text-xl text-neutral-neutral-9'>
          A meno del costo di un torneo all'anno, potrai diventare CLUB Member con accesso senza limiti a tutti i
          contenuti e sconti ESCLUSIVI dei nostri partner commerciali.
        </p>
      </div>

      <div className='my-8 grid items-start justify-center gap-8 md:grid-cols-2'>
        {pricingTiers.map((tier, index) => (
          <PricingCard key={index} tier={tier} />
        ))}
      </div>

      <div className='mt-32 flex items-center justify-center gap-5 text-center'>
        Per avere informazioni più dettagliate di cosa è incluso nella Tennistalker Club Membership
        <Button variant='outline' className='cursor-pointer' onClick={openLandingPageMembership}>
          <span>Clicca qui</span>
        </Button>
      </div>
    </div>
  );

  return (
    <Page
      title={user ? 'Gestisci la tua club membership' : 'Acquista Tennistalker Club Membership'}
      description={
        user
          ? 'Pagina di gestione della tua Tennistalker Club Membership'
          : 'Pagina di acquisto della Tennistalker Club Membership - versione premium di TennisTalker'
      }
    >
      <div className='my-10'>{isPremium ? <PremiumManagementContent /> : landingLink}</div>
    </Page>
  );
};

export default PremiumPage;
